import { useEffect, useState } from "react";
import { Sun, Cloud, CloudSun, CloudRain, CloudSnow, CloudLightning, CloudFog, CloudDrizzle, CloudRainWind, Wind, Droplets } from "lucide-react";
import { api } from "../../lib/api";

const ICON_MAP = {
  "sun": Sun,
  "cloud-sun": CloudSun,
  "cloud": Cloud,
  "cloud-rain": CloudRain,
  "cloud-rain-wind": CloudRainWind,
  "cloud-snow": CloudSnow,
  "cloud-lightning": CloudLightning,
  "cloud-fog": CloudFog,
  "cloud-drizzle": CloudDrizzle,
};

function Icon({ name, size = 22 }) {
  const C = ICON_MAP[name] || Cloud;
  return <C size={size} />;
}

const round = (n) => (n === null || n === undefined ? "—" : Math.round(n));

export default function WeatherWidget() {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let mounted = true;
    const load = () => api.get("/weather")
      .then((d) => { if (mounted) { setData(d); setError(""); } })
      .catch(() => mounted && setError("Hava servisi yanıt vermedi."));
    load();
    const t = setInterval(load, 15 * 60 * 1000);
    return () => { mounted = false; clearInterval(t); };
  }, []);

  if (error) {
    return (
      <div className="weather weather-err" data-testid="weather-widget">
        <Cloud size={20} />
        <div>
          <b>Hava durumu yok</b>
          <small>Bağlantı hatası</small>
        </div>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="weather weather-loading" data-testid="weather-widget">
        <Cloud size={20} />
        <div>
          <b>Yükleniyor...</b>
          <small>Bafra Sahilkent</small>
        </div>
      </div>
    );
  }

  const c = data.current || {};
  return (
    <>
      <button className="weather weather-btn" data-testid="weather-widget" onClick={() => setOpen(true)}>
        <div className="weather-icon"><Icon name={c.icon} size={22} /></div>
        <div className="weather-body">
          <b>{round(c.temp)}° {c.label}</b>
          <small>Bafra Sahilkent · Bugün</small>
        </div>
      </button>

      {open && (
        <div className="weather-sheet-backdrop" data-testid="weather-sheet" onClick={() => setOpen(false)}>
          <div className="weather-sheet" onClick={(e) => e.stopPropagation()}>
            <div className="weather-sheet-head">
              <span className="eyebrow"><span></span> HAVA DURUMU</span>
              <h2>Bafra Sahilkent</h2>
              <small>Samsun · Karadeniz Bölgesi</small>
            </div>

            <div className="weather-hero">
              <Icon name={c.icon} size={54} />
              <div>
                <b>{round(c.temp)}°</b>
                <span>{c.label}</span>
              </div>
              <div className="weather-metrics">
                <div><Wind size={14} /> {round(c.wind)} km/s</div>
                <div><Droplets size={14} /> %{round(c.humidity)}</div>
              </div>
            </div>

            <div className="weather-forecast">
              {(data.daily || []).map((d) => (
                <div className="weather-day" key={d.date}>
                  <span>{d.day_label}</span>
                  <Icon name={d.icon} size={22} />
                  <small>{d.label}</small>
                  <b>{round(d.max)}° <em>/ {round(d.min)}°</em></b>
                  {d.precip > 0 && <span className="weather-precip">{round(d.precip)} mm</span>}
                </div>
              ))}
            </div>

            <button className="outline-btn" data-testid="weather-close" onClick={() => setOpen(false)}>Kapat</button>
          </div>
        </div>
      )}
    </>
  );
}
